import React, { useEffect } from 'react';
import webBiLogger from '@wix/web-bi-logger';
import { offerView, offerMainCtaClick } from '@wix/bi-logger-personalize-data/v2';
import { navigateTo } from '@wix/business-manager-api';
import { Box, Text, Button, TextButton } from '@wix/design-system';
import s from './SetupSuggestedOptions.module.scss';
import { ReferralInfo } from './constants';
const injectMetasiteIdIfNeeded = (url, metaSiteId) => {
  return url.replace('<meta-site-id>', metaSiteId);
};
const getCtaActionOption = cta => {
  if (cta != null && cta.bizMgrNavigation) {
    return {
      ...cta.bizMgrNavigation,
      type: 'bizMgrNavigation'
    };
  } else if (cta != null && cta.externalUrl) {
    return {
      ...cta.externalUrl,
      type: 'externalUrl'
    };
  } else if (cta != null && cta.modal) {
    return {
      ...cta.modal,
      type: 'modal'
    };
  }
  return null;
};
export const SetupSuggestedOptionsWidget = _ref => {
  var _suggestion$creative;
  let {
    data: {
      metaSiteId,
      suggestions: [suggestion],
      placementId,
      userId,
      accountId
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const cta = getCtaActionOption((_suggestion$creative = suggestion.creative) == null ? void 0 : _suggestion$creative.cta);
  const biLogger = webBiLogger.factory().logger();
  const moreSuggestionsText = 'Show me a different suggestion';
  console.log('suggestion', suggestion);
  useEffect(() => {
    biLogger.report(offerView({
      msid: metaSiteId,
      loggedAccountId: accountId,
      loggedUserId: userId,
      topOfferName: suggestion.title,
      offerId: suggestion.offerId,
      realEstateId: placementId,
      http_referrer: window.location.href
    }));
  }, []);
  const onSuggestOtherClick = () => {
    onWidgetAction(SETUP_SUGGESTED_OPTIONS, {
      action: 'suggest other',
      value: moreSuggestionsText
    });
    send(moreSuggestionsText);
  };
  const onSuggestionClick = e => {
    var _cta$bizMgrNavigation, _cta$bizMgrNavigation2;
    e.stopPropagation();
    onWidgetAction(SETUP_SUGGESTED_OPTIONS, {
      action: 'main cta',
      value: suggestion.title
    });
    const event = {
      offerId: suggestion.offerId,
      realEstateId: placementId,
      msid: metaSiteId,
      http_referrer: window.location.href,
      action: 'CTA_CLICK',
      actionPriority: 1
    };
    switch (cta == null ? void 0 : cta.type) {
      case 'bizMgrNavigation':
        const navigationData = {
          ...(cta == null ? void 0 : cta.bizMgrNavigation),
          contextData: {
            ...(cta == null || (_cta$bizMgrNavigation = cta.bizMgrNavigation) == null ? void 0 : _cta$bizMgrNavigation.contextData),
            referrer: ReferralInfo
          }
        };
        if (cta != null && (_cta$bizMgrNavigation2 = cta.bizMgrNavigation) != null && _cta$bizMgrNavigation2.pageComponentId) {
          event.targetUrl = cta.bizMgrNavigation.pageComponentId;
        }
        navigateTo(navigationData);
        break;
      case 'externalUrl':
        const externalUrl = new URL(cta == null ? void 0 : cta.url);
        externalUrl.searchParams.set('referralInfo', ReferralInfo.DASHBOARD_SETUP);
        if (cta != null && cta.url) {
          event.targetUrl = cta.url;
        }
        window.open(injectMetasiteIdIfNeeded(decodeURI(externalUrl.toString()), metaSiteId));
        break;
    }
    biLogger.report(offerMainCtaClick(event));
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "10px"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "thin",
    size: "small",
    marginButton: "10px"
  }, "Here\u2019s what I suggest for you:"), /*#__PURE__*/React.createElement("div", {
    onClick: onSuggestionClick
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.SuggestionContainer,
    direction: "vertical",
    padding: "12px",
    gap: "12px",
    borderRadius: "8px",
    border: "1px solid",
    borderColor: "B40",
    width: "90%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, suggestion.description), /*#__PURE__*/React.createElement(Box, {
    align: "left"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    skin: "ai",
    onClick: onSuggestionClick
  }, (cta == null ? void 0 : cta.title) || 'Start now')))), /*#__PURE__*/React.createElement(TextButton, {
    weight: "thin",
    size: "tiny",
    onClick: onSuggestOtherClick
  }, moreSuggestionsText));
};
export const SETUP_SUGGESTED_OPTIONS = 'SETUP_SUGGESTED_OPTIONS';
//# sourceMappingURL=SetupSuggestedOptions.js.map